// extracted by mini-css-extract-plugin
export default {"page":"index_page_zKRC0","webPage":"index_webPage_D4i6E","box":"index_box_Dldkz"};